import { Bot, Compass, Sparkles, Stars, Zap, type LucideIcon } from 'lucide-react';

export const AI_PREFILL_PROMPT =
  'Я сейчас пришлю тебе корпоративную IT-инструкцию — она уже у меня в буфере обмена. Попроси меня её вставить (Ctrl+V или Cmd+V на Mac) и пока больше ничего не пиши. Когда я пришлю текст, помоги мне его разобрать, объясни непонятные шаги и помоги решить возникающие трудности.';

export type AiProviderId = 'chatgpt' | 'claude' | 'perplexity' | 'grok' | 'scira';

export type AiProvider = {
  id: AiProviderId;
  label: string;
  Icon: LucideIcon;
  authRequired: boolean;
  getUrl: (q: string) => string;
};

export const AI_PROVIDERS: readonly AiProvider[] = [
  {
    id: 'chatgpt',
    label: 'ChatGPT',
    Icon: Sparkles,
    authRequired: false,
    getUrl: (q) => `https://chatgpt.com/?q=${q}`,
  },
  {
    id: 'perplexity',
    label: 'Perplexity',
    Icon: Compass,
    authRequired: false,
    getUrl: (q) => `https://www.perplexity.ai/search?q=${q}`,
  },
  {
    id: 'scira',
    label: 'Kimi',
    Icon: Stars,
    authRequired: false,
    getUrl: (q) => `https://scira.ai/?q=${q}`,
  },
  {
    id: 'claude',
    label: 'Claude',
    Icon: Bot,
    authRequired: true,
    getUrl: (q) => `https://claude.ai/new?q=${q}`,
  },
  {
    id: 'grok',
    label: 'Grok',
    Icon: Zap,
    authRequired: true,
    getUrl: (q) => `https://grok.com/?q=${q}`,
  },
];
